/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CountryCode } from "./CountryCode";
import {
  CountryCodeFromJSON,
  CountryCodeFromJSONTyped,
  CountryCodeToJSON,
  CountryCodeToJSONTyped,
} from "./CountryCode";

/**
 *
 * @export
 * @interface Address
 */
export interface Address {
  /**
   *
   * @type {string}
   * @memberof Address
   */
  addressLine?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  addressLine2?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  stateOrProvinceCode?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  postalCode?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof Address
   */
  countryCode?: CountryCode;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): value is Address {
  return true;
}

export function AddressFromJSON(json: any): Address {
  return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Address {
  if (json == null) {
    return json;
  }
  return {
    addressLine: json["addressLine"] == null ? undefined : json["addressLine"],
    addressLine2:
      json["addressLine2"] == null ? undefined : json["addressLine2"],
    city: json["city"] == null ? undefined : json["city"],
    stateOrProvinceCode:
      json["stateOrProvinceCode"] == null
        ? undefined
        : json["stateOrProvinceCode"],
    postalCode: json["postalCode"] == null ? undefined : json["postalCode"],
    countryCode:
      json["countryCode"] == null
        ? undefined
        : CountryCodeFromJSON(json["countryCode"]),
  };
}

export function AddressToJSON(json: any): Address {
  return AddressToJSONTyped(json, false);
}

export function AddressToJSONTyped(
  value?: Address | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    addressLine: value["addressLine"],
    addressLine2: value["addressLine2"],
    city: value["city"],
    stateOrProvinceCode: value["stateOrProvinceCode"],
    postalCode: value["postalCode"],
    countryCode: CountryCodeToJSON(value["countryCode"]),
  };
}
